/*eslint-disable eqeqeq*/
import React from 'react';
import { I18n as I } from 'react-redux-i18n';

import { isNil, lpad, getCountdown } from 'vdlib';

const redStyle = {
    color: 'red',
    marginTop: '-9px',
    fontSize: 16,
    fontWeigth: 600,
  },
  greenStyle = { color: 'green' },
  grayStyle = { color: '#94A0B2' };

class TimeCellRenderer extends React.Component {
  constructor(props) {
    super(props);

    this.state = { countdown: getCountdown(this.props.value) };
  }

  componentDidMount() {
    this.intervalRef = setInterval(() => {
      let countdown = getCountdown(this.props.value);
      this.setState({ countdown });
      if (countdown.done) clearInterval(this.intervalRef);
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalRef);
  }

  render() {
    if (isNil(this.state.countdown)) return false;

    if (this.props.onlineMode) return <div style={redStyle}>LIVE</div>;
    if (this.state.countdown.done && this.state.countdown.days == 0)
      return <div style={redStyle}>{I.t('OVERDUE')}</div>;
    else if (this.state.countdown.done)
      return <span style={grayStyle}>{I.t('OVERDUE')}</span>;
    else if (this.state.countdown.days > 0)
      return (
        <span style={greenStyle}>
          {this.state.countdown.days} {I.t('DAY_NO_ENDING')}
          {this.state.countdown.days == 1
            ? I.t('ENDING_FEMALE_SINGULAR')
            : I.t('ENDING_FEMALE_PLURAL')}
        </span>
      );

    let colorStyle =
      this.state.countdown.days === 0 && this.state.countdown.hours <= 3
        ? redStyle
        : greenStyle;
    //const finished = this.state.countdown.days < 0 || (this.state.countdown.days == 0 && this.state.countdown.hours == 0 && this.state.countdown.minutes == 0 && this.state.countdown.seconds == 0);
    return (
      <span style={colorStyle}>
        {lpad(
          this.state.countdown.days * 24 + this.state.countdown.hours,
          2,
          '0'
        )}{' '}
        :{lpad(this.state.countdown.minutes, 2, '0')} :
        {lpad(this.state.countdown.seconds, 2, '0')}
      </span>
    );
  }
}

export default TimeCellRenderer;
